export default __webpack_public_path__ + "static/media/profile-cover.f0343f9e.jpg";